module.exports = __webpack_public_path__ + "img/userB16.2d563865.jpg";